import { FormLeavingListener } from '@exam-center/components';
import { ExamCenterDetailsInfoBanner } from '@exam-center/exam-center-management';
import {
  Box,
  Divider,
  Flex,
  Form,
  FormButton,
  FormTextField,
  PaperSection,
  ReadonlyField,
  Text,
} from '@shared/components';
import { FormProvider, type UseFormReturn, type SubmitHandler } from 'react-hook-form';

interface ExamCenterDetailsFormType {
  nameTH: string;
  addressTH: string;
  phoneTH: string;
  nameEN: string;
  addressEN: string;
  phoneEN: string;
  website: string;
  email: string;
  examResultRecipientEmail: string;
}

interface ExamCenterDetailsFormProps {
  code: string;
  form: UseFormReturn<ExamCenterDetailsFormType>;
  onSubmit: SubmitHandler<ExamCenterDetailsFormType>;
}

export default function ExamCenterDetailsForm(props: Readonly<ExamCenterDetailsFormProps>) {
  const { form, code, onSubmit } = props;

  return (
    <FormProvider {...form}>
      <Form
        onSubmit={form.handleSubmit(onSubmit)}
        sx={(theme) => ({ display: 'flex', flexDirection: 'column', gap: theme.spacing(6) })}
      >
        <PaperSection title='ข้อมูลศูนย์ทดสอบ' sx={{ height: '100%' }}>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              flex: 1,
              p: theme.spacing(6),
              gap: theme.spacing(6),
            })}
          >
            <ExamCenterDetailsInfoBanner />
            <Flex sx={{ width: '100%' }}>
              <Text variant='body1Semibold' sx={{ flexBasis: 240 }}>
                Exam Center Code
              </Text>
              <Box sx={{ width: '240px' }}>
                <ReadonlyField content={code} />
              </Box>
            </Flex>

            <Flex sx={{ width: '100%' }}>
              <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
                ข้อมูลภาษาไทย
              </Text>
              <Flex sx={(theme) => ({ flexDirection: 'column', flex: 1, gap: theme.spacing(4) })}>
                <FormTextField
                  name='nameTH'
                  label='ชื่อศูนย์ทดสอบ (ภาษาไทย)'
                  placeholder='กรอกชื่อศูนย์ทดสอบ (ภาษาไทย)'
                  required
                />
                <FormTextField
                  name='addressTH'
                  label='ที่อยู่ (ภาษาไทย)'
                  placeholder='กรอกที่อยู่'
                  required
                />
                <FormTextField
                  name='phoneTH'
                  label='โทรศัพท์ (ภาษาไทย)'
                  placeholder='กรอกเบอร์โทรศัพท์'
                  required
                />
              </Flex>
            </Flex>

            <Divider />

            <Flex sx={{ width: '100%' }}>
              <Text variant='body1Semibold' sx={{ flexBasis: '240px' }}>
                ข้อมูลภาษาอังกฤษ
              </Text>
              <Flex sx={(theme) => ({ flexDirection: 'column', flex: 1, gap: theme.spacing(4) })}>
                <FormTextField
                  name='nameEN'
                  label='ชื่อศูนย์ทดสอบ (ภาษาอังกฤษ)'
                  required
                  placeholder='กรอกชื่อศูนย์ทดสอบ (ภาษาอังกฤษ)'
                />
                <FormTextField
                  name='addressEN'
                  label='ที่อยู่ (ภาษาอังกฤษ)'
                  placeholder='กรอกที่อยู่'
                  required
                />
                <FormTextField
                  name='phoneEN'
                  label='โทรศัพท์ (ภาษาอังกฤษ)'
                  placeholder='กรอกเบอร์โทรศัพท์'
                  required
                />
              </Flex>
            </Flex>

            <Divider />

            <Flex sx={{ width: '100%' }}>
              <Text variant='body1Semibold' sx={{ flexBasis: 240 }}>
                เว็บไซต์และอีเมล
              </Text>
              <Flex sx={(theme) => ({ flexDirection: 'column', flex: 1, gap: theme.spacing(4) })}>
                <FormTextField
                  name='website'
                  label='เว็บไซต์'
                  placeholder='กรอกชื่อเว็บไซต์'
                  helperText='URL ต้องขึ้นต้นด้วย http:// หรือ https:// เช่น http://www.example.com'
                  required
                />
                <FormTextField name='email' label='อีเมล' placeholder='กรอกอีเมล' required />
                <FormTextField
                  name='examResultRecipientEmail'
                  label='อีเมลรับผลการสอบ (BCC)'
                  placeholder='กรอกอีเมลรับผลการสอบ'
                  helperText='อีเมลนี้จะได้รับสำเนาอีเมลผลการสอบของผู้เข้าสอบทุกคน เพื่อให้ศูนย์ทดสอบส่งต่อให้ผู้เข้าสอบเองได้ กรณีผู้เข้าสอบไม่ได้รับอีเมล'
                  required
                />
              </Flex>
            </Flex>
          </Flex>
        </PaperSection>

        <Flex sx={{ justifyContent: 'flex-end' }}>
          <FormButton size='large' type='submit' label='บันทึก' />
        </Flex>
      </Form>
      <FormLeavingListener onSubmit={onSubmit} />
    </FormProvider>
  );
}
